module.exports = __webpack_public_path__ + "media/images/icons/material/bookmark-outline-97863f714d748c78f553eedbdf786bca.svg";